import axios from 'axios';
import resolve  from './../resolver.js';
import checkJwt from '../../Global/jwtChecker';
import logout from '../../Global/logout';

export default async function getProviderTaxRatesList(
    data
) {
    
    const unHashedJwt = await checkJwt()

    if(!unHashedJwt){
        logout()
    }

    let query = "&page" + data.activePage +
        "&size=" + data.pageSize

    if(data.activeOnly === "Active"){
        query += "&onlyActive=true"
    }
    else if(data.activeOnly === "Inactive"){
        query += "&onlyActive=false"
    }
        

    return await resolve(
        axios( process.env.REACT_APP_DEFAULT_API_PREFIX + 'provider/taxRate/list?countryUuid=' + data.taxRatesPickedCountry.value + query, {
            method: 'GET',
            headers: { 'Authorization' : unHashedJwt}           
        }).then(res => res)
        .catch(error => logout())
    );
}